<template>
  <div style="padding: 10px">
    <div style="display: flex; justify-content: flex-end">
      <el-form
        :inline="true"
        size="small"
        :model="searchForm"
        class="search-form"
      >
        <el-form-item label="报警时间范围">
          <el-date-picker
            v-model="searchForm.timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="报警类型">
          <el-select
            v-model="searchForm.alertType"
            placeholder="请选择报警类型"
          >
            <el-option label="类型一" value="type1"></el-option>
            <el-option label="类型二" value="type2"></el-option>
            <el-option label="类型三" value="type3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchAlerts">搜索</el-button>
          <el-button type="success" @click="exportData">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table :data="displayedAlerts" style="width: 100%">
        <el-table-column prop="vehicle" label="报警车辆"></el-table-column>
        <el-table-column prop="alertType" label="报警类型"></el-table-column>
        <el-table-column prop="alertTime" label="报警时间"></el-table-column>
        <el-table-column prop="source" label="报警来源"></el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="totalAlerts"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alerts: [
        {
          vehicle: "车辆1",
          alertType: "type1",
          alertTime: "2025-01-01 10:00:00",
          source: "来源1",
        },
        {
          vehicle: "车辆2",
          alertType: "type2",
          alertTime: "2025-01-05 15:30:00",
          source: "来源2",
        },
        {
          vehicle: "车辆3",
          alertType: "type3",
          alertTime: "2025-01-10 08:15:00",
          source: "来源3",
        },
        {
          vehicle: "车辆1",
          alertType: "type1",
          alertTime: "2025-01-12 14:20:00",
          source: "来源1",
        },
        {
          vehicle: "车辆2",
          alertType: "type2",
          alertTime: "2025-01-15 09:45:00",
          source: "来源2",
        },
        {
          vehicle: "车辆3",
          alertType: "type3",
          alertTime: "2025-01-20 11:30:00",
          source: "来源3",
        },
        {
          vehicle: "车辆1",
          alertType: "type1",
          alertTime: "2025-01-22 13:10:00",
          source: "来源1",
        },
        {
          vehicle: "车辆2",
          alertType: "type2",
          alertTime: "2025-01-25 16:50:00",
          source: "来源2",
        },
        {
          vehicle: "车辆3",
          alertType: "type3",
          alertTime: "2025-01-28 07:20:00",
          source: "来源3",
        },
        {
          vehicle: "车辆1",
          alertType: "type1",
          alertTime: "2025-01-30 17:40:00",
          source: "来源1",
        },
      ],
      searchForm: {
        timeRange: [], // 存储用户选择的报警时间范围
        alertType: "", // 存储用户选择的报警类型
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示数量
      totalAlerts: 0, // 总报警数据数量
      displayedAlerts: [], // 当前显示的报警数据
    };
  },
  created() {
    this.searchAlerts();
  },
  methods: {
    searchAlerts() {
      let filteredAlerts = this.alerts;
      if (this.searchForm.timeRange.length > 0) {
        const [startDate, endDate] = this.searchForm.timeRange;
        filteredAlerts = filteredAlerts.filter((alert) => {
          const alertTime = new Date(alert.alertTime);
          const startTime = new Date(startDate);
          const endTime = new Date(endDate);
          return alertTime >= startTime && alertTime <= endTime;
        });
      }
      if (this.searchForm.alertType) {
        filteredAlerts = filteredAlerts.filter(
          (alert) => alert.alertType === this.searchForm.alertType
        );
      }
      this.totalAlerts = filteredAlerts.length;
      this.displayedAlerts = this.paginate(filteredAlerts);
    },
    paginate(alerts) {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return alerts.slice(start, end);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.searchAlerts();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.searchAlerts();
    },
    exportData() {
      // 这里使用简单的 CSV 导出示例，可根据需求使用其他库实现更复杂的导出功能
      let csvContent = "报警车辆,报警类型,报警时间,报警来源\n";
      this.displayedAlerts.forEach((alert) => {
        csvContent += `${alert.vehicle},${alert.alertType},${alert.alertTime},${alert.source}\n`;
      });
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "alerts.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
